<app-page-heading [heading]="heading" [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="tabName">
</app-page-heading>

<!---------------------------->
<!-- Section Banner-->
<!---------------------------->
<ng-container *ngIf="!isAllowedToSubmitProviderNetwork()">
  <app-banner [bannerText]="bannerText"></app-banner>
</ng-container>

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    
    <!----------------------------->
    <!---- STEP: General:---->
    <!----------------------------->
    
    <mat-step #generalStep [completed]="productNetworkFormGroup.valid">
      <ng-template matStepLabel>General</ng-template>
      <form [formGroup]="productNetworkFormGroup">
        
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Network Name</mat-label>
              <input matInput type="text" [formControlName]="controls.Name" required
                     (input)="onUpdateProviderNetworkHeading($any($event).target.value)">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Network Name')">help_outline</mat-icon>
          </mat-grid-tile>
          
          
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Code</mat-label>
              <input matInput type="text" [formControlName]="controls.Code" required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Network Name')">help_outline</mat-icon>
          </mat-grid-tile>
        
        </mat-grid-list>
        
        <mat-grid-list cols="2" rowHeight="75px">
          
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Administrator</mat-label>
              <mat-select [formControlName]="controls.Administrator" required>
                <mat-option *ngFor="let option of administratorLoopUpValues" [value]="option.value">
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Administrator')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Start Date</mat-label>
              <input [formControlName]='controls.StartDate'
                     [matDatepicker]="startDatePicker" matInput required
                     [max]="productNetworkFormGroup.controls[controls.EndDate].value">
              <mat-datepicker-toggle [for]="startDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Start Date')">help_outline</mat-icon>
          </mat-grid-tile>
          
        </mat-grid-list>
        
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Grading</mat-label>
              <input matInput type="text" [formControlName]="controls.Grading">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Grading')">help_outline</mat-icon>
          </mat-grid-tile>
          
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>End Date</mat-label>
              <input [formControlName]='controls.EndDate'
                     [matDatepicker]="endDatePicker" matInput
                     [min]="productNetworkFormGroup.controls[controls.StartDate].value">
              <mat-datepicker-toggle [for]="endDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('End Date')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        
        <div class="button-container">
          <button mat-raised-button color="warn" (click)="resetProviderNetworkFormGroup();">Clear</button>
          <button mat-raised-button matStepperNext color="primary"
                  [disabled]="!productNetworkFormGroup.valid">Next
          </button>
        </div>
      </form>
    </mat-step>
    
    <!------------------------------->
    <!-- STEP: Providers:-->
    <!------------------------------->
    
    <mat-step #providerStep [completed]="selectedProviders.length>0">
      <ng-template matStepLabel>Providers</ng-template>
      
      <div class="header-container">
        <div>
          <p>Select providers using the filter and sort functions</p>
        </div>
        
        <span class="header-spacer"></span>
        
        <button class="button-spacer fit-content" style="width: fit-content" mat-raised-button (click)="downloadFile()"
                color="accent">
          <mat-icon>arrow_downward</mat-icon>
          Download Template
        </button>
        
        
        <button class="button-spacer fit-content" (click)="fileInput.click()" color="accent" mat-raised-button>
          <mat-icon>arrow_upward</mat-icon>
          Import Providers
          <input #fileInput type="file" accept=".csv" (change)="fileUploadListener($event)" style="display:none;"/>
        </button>
      </div>
      
      <br/>
      
      <div>
        <mat-slide-toggle #toggleSelectedProviders (change)="toggleShowSelectedProviders()">
          Selected Providers
        </mat-slide-toggle>
      </div>
      
      <br/>
      
      <div *ngIf="providerDataSource" class="mat-elevation-z8 table-container">
        <table mat-table multiTemplateDataRows [dataSource]="providerDataSource"
               matSort (matSortChange)="sortData($event)">
          
          <ng-container [matColumnDef]="tableColumns.Select">
            <th style="width: 36px" mat-header-cell *matHeaderCellDef>
            </th>
            <td style="width: 36px" mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? toggleSelect(row) : null" [checked]="isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.ProviderId">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider Id</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerId }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.PracticeNumber">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              <mat-form-field class="w-100">
                <textarea matInput class="table-column-filter"
                          #autosize="cdkTextareaAutosize" cdkTextareaAutosize
                          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                          [(ngModel)]="practiceNumberSearch"
                          (input)="onInputChangedFilterData($event, tableColumns.PracticeNumber)"
                          (keydown.space)="$event.stopPropagation()"
                          (click)="$event.stopPropagation();" placeholder="Practice Number"></textarea>
              </mat-form-field>
            </th>
            <td *matCellDef="let row" mat-cell>{{ row.practiceNumber }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.Name">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              <mat-form-field class="w-100">
              <textarea matInput class="table-column-filter"
                        #autosize="cdkTextareaAutosize" cdkTextareaAutosize
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                        [(ngModel)]="providerNameSearch"
                        (input)="onInputChangedFilterData($event, tableColumns.Name)"
                        (keydown.space)="$event.stopPropagation()"
                        (click)="$event.stopPropagation();" placeholder="Provider Name"></textarea>
              </mat-form-field>
            </th>
            <td *matCellDef="let row" mat-cell>{{ row.name }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.BusinessType">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Business Type</th>
            <td *matCellDef="let row" mat-cell>{{ row.businessType?.name }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.EntityStatus">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Entity Status</th>
            <td *matCellDef="let row" mat-cell>{{ row.entityStatus?.name }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.ProviderFacilityType">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Facility Type</th>
            <td *matCellDef="let row" mat-cell>{{ row.providerFacilityType?.name }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.StartDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
            <td *matCellDef="let row" mat-cell>{{ row.startDate | date: dateFormat }}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.EndDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
            <td *matCellDef="let row" mat-cell>{{ row.endDate | date: dateFormat }}</td>
          </ng-container>
          
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="providerDisplayedColumns.length">
              <div class="row-detail-container" [@detailExpand]="row == providerExpandedRow ? 'expanded' : 'collapsed'">
                <b>Provider Name: </b>{{ row.name }}<br>
                <b>License Number: </b>{{ row.businessLicenseNumber | slice:0:25 }}<br>
                <b>License Expiry: </b>{{ row.businessLicenseExpiryDate | date: dateFormat }}<br>
                <b>GST Number: </b>{{ row.gstNumber }}<br>
                <b>Billing Id: </b>{{ row.billingId }}<br>
                <b>Country: </b>{{ row.country?.name }}<br>
                <b>Regulator: </b>{{ row.regulator?.name }}<br>
                <b>Processing Class: </b>{{ row.processingClass?.name }}<br>
                <b>Vat Number: </b>{{ row.vatNumber }}<br>
                <b>Vat Override: </b>{{ row.vatOverride }}<br>
                <b>Sanction Indicator: </b>{{ row.sanctionIndicator }}<br>
                <b>Sanction Reference: </b>{{ row.sanctionReference }}<br>
                <b>Sanction Check Date: </b>{{ row.sanctionCheckDate | date: dateFormat }}<br>
                <b>Created By: </b>{{ row.createdBy }}<br>
                <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
                <b>Updated By: </b>{{ row.updatedBy }}<br>
                <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="providerDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let tableRow; columns: providerDisplayedColumns;" class="row"
              [class.expanded-row]="providerExpandedRow == tableRow && !toggleSelectedProviders.checked"
              (click)="providerExpandedRow = providerExpandedRow === tableRow ? null : tableRow">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
        </table>
        
        <mat-paginator #providerNetworksPaginator (page)="pageChanged($event)"
                       [length]="providerTableControl.length" [pageSize]="providerTableControl.pageSize"
                       [pageIndex]="0" [pageSizeOptions]="providerTableControl.pageSizeOptions">
        </mat-paginator>
      
      </div>
      
      <div class="button-container">
        <button mat-raised-button matStepperPrevious color="primary">Back</button>
        <button mat-raised-button color="warn"
                [disabled]="!isAllowedToSubmitProviderNetwork()"
                (click)="resetProviderState();">
          Clear
          <mat-icon *ngIf="!isAllowedToSubmitProviderNetwork()" class="info-icon"
                    [matTooltip]="getClearButtonTooltip()">
            help_outline
          </mat-icon>
        </button>
        <button mat-raised-button matStepperNext color="primary"
                [disabled]="isFinishButtonDisabled()"
                (click)="saveProviderNetworkDTO()">
          Finish
          <mat-icon *ngIf="isFinishButtonDisabled()" class="info-icon"
                    [matTooltip]="getFinishButtonTooltip()">
            help_outline
          </mat-icon>
        </button>
      </div>
    </mat-step>
  
  </mat-horizontal-stepper>
</div>
